import { alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(
  ({ spacing, palette, transitions }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),

      '& a': {
        color: 'inherit',
        fontWeight: 'bold',
      },
    },

    point: {
      margin: 0,
    },

    pointCheckbox: {
      padding: 0,
      marginRight: spacing(2),
      alignSelf: 'start',
      color: 'currentColor',

      '&, &.Mui-checked': {
        color: 'currentColor',
      },
    },

    submit: {
      margin: spacing(0, 2),
      backgroundColor: palette.primary.contrastText,
      transition: transitions.create('background-color', {
        duration: transitions.duration.shortest,
      }),
      fontWeight: 'bold',

      '&:disabled': {
        backgroundColor: alpha(palette.primary.contrastText, 0.5),
      },

      '&:hover': {
        backgroundColor: alpha(palette.primary.contrastText, 0.8),
      },

      '&, &:disabled, &:hover': {
        color: palette.primary.main,
        border: 'none',
      },
    },

    submitSpinner: {},
  }),
  {
    name: 'ConsentForm',
  },
);
